import { Button, Typography, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "85vh",
    textAlign: "center",
  },
  errorMessage: {
    marginBottom: theme.spacing(2),
  },
  actionBtn: {
    cursor: "pointer"
  }
}));

const ErrorPage = ({ resetError = () => {} } = {}) => {
  const classes = useStyles();
  const history = useHistory();

  const redirectToDashboard = () => {
    //resetting the error
    resetError?.();
    history.push("/dashboard");
  };

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.errorMessage}>
        Oops! Something went wrong.
      </Typography>
      <Typography variant="body1">
        We're sorry, but an error occurred. Please try again later.
      </Typography>
      <Button variant="contained" color="primary" onClick={redirectToDashboard} className={classes.actionBtn}>
        Go to Dashboard
      </Button>
    </div>
  );
};

export default ErrorPage;
